export default __webpack_public_path__ + "4af10a9d5d4ea7de5a33fba1eb5faca7.svg";